import {BaseContainerModel} from '../../base-container.model';
import {
  bl_fi_cashbook_txn_line_RowClass
} from '../../../dbschema/index';

export class CashbookTxnLineContainerModel2 extends BaseContainerModel {
  bl_fi_cashbook_txn_line: bl_fi_cashbook_txn_line_RowClass[] = new Array();

}
